import * as StripeCardCvcField from './stripe-card-cvc-field';
import * as StripeCardExpiryField from './stripe-card-expiry-field';
import * as StripeCardNumberField from './stripe-card-number-field';

export const Stripe = {
  ...StripeCardCvcField,
  ...StripeCardExpiryField,
  ...StripeCardNumberField,
} as const;
